import { summaryApi } from "../common";

const fetchAllCategories = async (productsCategory) => {
    try {
        // First, get all products
        const response = await fetch(summaryApi.allProducts.url, {
            method: summaryApi.allProducts.method,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const responseData = await response.json();

        // Check if the request was successful
        if (responseData.success) {
            let filteredProducts = responseData.data;
            
            // Filter products by category if provided
            if (productsCategory) {
                if (Array.isArray(productsCategory)) {
                    // If it's an array of categories, filter by any matching category
                    filteredProducts = responseData.data.filter(product => 
                        productsCategory.includes(product.productsCategory)
                    );
                } else {
                    // If it's a single category string, filter by that category
                    filteredProducts = responseData.data.filter(product => 
                        product.productsCategory === productsCategory
                    );
                }
            }

            return {
                data: filteredProducts,
                success: true,
                message: "Products fetched successfully"
            };
        } else {
            throw new Error(responseData.message || "Failed to fetch products");
        }
    } catch (error) {
        console.error("Error in fetchAllCategories:", error);
        return {
            data: [],
            success: false,
            message: error.message
        };
    }
}

export default fetchAllCategories;